<template>
    <div>
        <navigation/>

        <centered-card headline="My Profile">
            <profile-form/>
        </centered-card>
        <div class="card-spacer"></div>


    </div>
</template>

<script>
    import Navigation from '../layout/MainNavigation.vue';
    import CenteredCard from '../layout/CenteredCard.vue';
    import ProfileForm from './ProfileForm.vue';

    export default {
        name: 'Profile',
        metaInfo: {
            title: 'Your Pimblr Profile'
        },
        data() {
            return {}
        },

        methods: {},
        components: {
            Navigation,
            CenteredCard,
            ProfileForm
        }
    }
</script>

<style lang="sass">
    .card-spacer
        margin-top: 3em;
</style>



// WEBPACK FOOTER //
// src/components/user/ProfilePage.vue